import type { OverlayBadgeDesignTokens } from '@primeuix/themes/types/overlaybadge';

export default {
    root: {
        outline: {
            width: '2px',
            color: 'transparent',
        },
    },
} satisfies OverlayBadgeDesignTokens;
